/** @format */
import {
    Query,
    SearchListingModel,
    SearchListingProduct,
} from '@toucan/common/services/search/types';

import { ListingPageProps, ListingPageVariant } from '../index';

export function formatSearchFacetNumber(
    number: number | string,
    market: string
): string {
    return number
        .toString()
        .replace(/[\d.]+/g, (value) =>
            Intl.NumberFormat(market).format(parseFloat(value))
        );
}

function isSearchListingModel(
    result: SearchListingProduct | SearchListingModel
): result is SearchListingModel {
    return 'productPriceCount' in result;
}

export function getSingleProductModel(
    results: (SearchListingProduct | SearchListingModel)[]
): SearchListingModel | null {
    const [firstResult] = results;

    const hasOneResult = results.length === 1;

    if (!hasOneResult || !isSearchListingModel(firstResult)) return null;

    const productCount = parseInt(
        firstResult.productPriceCount?.values?.[0] ?? ''
    );
    const hasOneProduct = productCount === 1;

    return hasOneProduct ? firstResult : null;
}

// eslint-disable-next-line @mpb-com/mpb/boolean-function-prefix -- Legacy code: do not use as an example.
const validateQueryObject = (queryObject: object) => {
    for (const queryParameter of Object.values(queryObject)) {
        if (typeof queryParameter === 'object') {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
            if (!validateQueryObject(queryParameter)) {
                return false;
            }
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
        const isUndefinedQueryParameter = /undefined/i.test(queryParameter);

        if (isUndefinedQueryParameter) {
            return false;
        }
    }

    return true;
};

// eslint-disable-next-line @mpb-com/mpb/boolean-function-prefix -- Legacy code: do not use as an example.
export const validateBaseQuery = (baseQuery: Partial<Query>) => {
    if (Object.keys(baseQuery).length === 0) {
        return false;
    }

    return validateQueryObject(baseQuery);
};

export const getNumFilterSkeletons = ({
    variant,
    showProductNames,
}: Pick<ListingPageProps, 'variant' | 'showProductNames'>) => {
    const numModelFilters = 10;
    const numProductFilters = 3;

    if (variant === ListingPageVariant.MODEL || showProductNames)
        return numModelFilters;

    return numProductFilters;
};

export const shouldShowFacetCount = ({
    id,
    variant,
}: {
    id: string;
    variant: ListingPageVariant;
}) => {
    switch (variant) {
        case ListingPageVariant.MODEL:
            return !id.startsWith('product') && !/^model(\w+)Num$/.test(id);
        case ListingPageVariant.PRODUCT:
        default:
            return true;
    }
};
